import { render, staticRenderFns } from "./ProductoPresentacionModal.vue?vue&type=template&id=2f752833&"
import script from "./ProductoPresentacionModal.vue?vue&type=script&lang=js&"
export * from "./ProductoPresentacionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports